import Cookies from 'js-cookie'

const COOKIE_KEY = 'dsa_report_locale'

export const SCORE_REPORT_LOCALES = ['en', 'zh']

const COPY = {
  en: {
    langName: 'English',
    back: 'Back',
    downloadPdf: 'Download PDF',
    preparingPdf: 'Preparing PDF…',
    print: 'Print',
    openVerify: 'Open verify page',
    loading: 'Loading official transcript…',
    unavailable: 'Official score report not available.',
    institutionBanner: 'Institution view — you are viewing a student transcript for your school.',
    officialTranscript: 'OFFICIAL TRANSCRIPT',
    scoreReport: 'Official Score Transcript',
    brandSub: 'Official Score Transcript',
    brandName: 'DEEP SCHOLASTIC ASSESSMENT',
    candidate: 'Candidate',
    candidateName: 'Candidate Name',
    name: 'Name',
    dob: 'Date of birth',
    dobShort: 'DOB',
    email: 'Email',
    gender: 'Gender',
    examId: 'Exam ID',
    subject: 'Subject',
    discipline: 'Discipline',
    subjectCode: 'Subject Code',
    consolidatedScore: 'Consolidated Score',
    scoreBreakdown: 'Score Breakdown',
    assessmentHistory: 'Assessment History',
    date: 'Date',
    testingWindow: 'Window',
    attempt: 'Attempt',
    raw: 'Raw',
    windowBonus: 'W. Bonus',
    headroom: 'Headroom',
    effectiveBonus: 'Eff. Bonus',
    credit: 'Credit',
    scoreCalculation: 'Score Calculation',
    selectedHighest: 'Selected (highest)',
    performanceScale: 'Performance Scale',
    reference: 'Reference',
    verification: 'Verification',
    reportId: 'Report ID',
    issueDate: 'Issue Date',
    validUntil: 'Valid Until',
    verifyAt: 'Verify at',
    certification: 'Certification',
    scanToVerify: 'Scan to Verify',
    notes: 'Notes',
    policyVisit: 'For detailed scoring methodology, visit',
    code: 'Code',
    verifyTitle: 'Verify a score report',
    verifySub: 'Enter the Report ID printed on an official DSA transcript to confirm authenticity.',
    verifyBtn: 'Verify',
    checking: 'Checking…',
    verifying: 'Verifying…',
    notVerified: 'Not verified',
    verifiedOk: 'Verified authentic',
    verifiedExpired: 'Found but expired',
    disclosedAttempts: 'Disclosed attempts',
    performanceLevel: 'Performance Level',
    couldNotLoad: 'Could not load score report',
    couldNotPdf: 'Could not generate PDF',
    couldNotDownload: 'Could not download PDF',
    verifyFailed: 'Verification request failed',
    reportNotFound: 'Report not found',
  },
  zh: {
    langName: '中文',
    back: '返回',
    downloadPdf: '下载 PDF',
    preparingPdf: '正在生成 PDF…',
    print: '打印',
    openVerify: '打开验证页',
    loading: '正在加载正式成绩单…',
    unavailable: '暂无正式成绩单。',
    institutionBanner: '机构视图 — 您正在查看本校学生的成绩单。',
    officialTranscript: '正式成绩单',
    scoreReport: '官方成绩誊本',
    brandSub: '官方成绩誊本',
    brandName: 'DEEP SCHOLASTIC ASSESSMENT',
    candidate: '考生信息',
    candidateName: '考生姓名',
    name: '姓名',
    dob: '出生日期',
    dobShort: '出生日期',
    email: '邮箱',
    gender: '性别',
    examId: '考试编号',
    subject: '科目',
    discipline: '学科门类',
    subjectCode: '科目代码',
    consolidatedScore: '综合分（Consolidated Score）',
    scoreBreakdown: '成绩构成',
    assessmentHistory: '考试历史',
    date: '日期',
    testingWindow: '窗口',
    attempt: '尝试',
    raw: '原始分',
    windowBonus: '窗口加分',
    headroom: '余量',
    effectiveBonus: '有效加分',
    credit: '计入比例',
    scoreCalculation: '分数计算',
    selectedHighest: '已选用（最高）',
    performanceScale: '表现等级量表',
    reference: '参考',
    verification: '验证信息',
    reportId: '报告编号',
    issueDate: '签发日期',
    validUntil: '有效期至',
    verifyAt: '验证地址',
    certification: '认证声明',
    scanToVerify: '扫码验证',
    notes: '说明',
    policyVisit: '详细评分方法请见',
    code: '验证码',
    verifyTitle: '验证成绩单',
    verifySub: '请输入正式 DSA 成绩单上的 Report ID，以确认真伪。',
    verifyBtn: '验证',
    checking: '验证中…',
    verifying: '正在验证…',
    notVerified: '未能验证',
    verifiedOk: '验证通过（真实有效）',
    verifiedExpired: '已找到但已过期',
    disclosedAttempts: '已披露的尝试',
    performanceLevel: '表现等级',
    couldNotLoad: '无法加载成绩单',
    couldNotPdf: '无法生成 PDF',
    couldNotDownload: '无法下载 PDF',
    verifyFailed: '验证请求失败',
    reportNotFound: '未找到该报告',
  },
}

export function getScoreReportLocale() {
  const raw = (Cookies.get(COOKIE_KEY) || '').toLowerCase()
  if (SCORE_REPORT_LOCALES.includes(raw)) return raw
  return 'en'
}

export function setScoreReportLocale(locale) {
  const next = SCORE_REPORT_LOCALES.includes(locale) ? locale : 'en'
  Cookies.set(COOKIE_KEY, next, { expires: 365 })
  return next
}

export function scoreReportCopy(locale) {
  const key = SCORE_REPORT_LOCALES.includes(locale) ? locale : 'en'
  return COPY[key]
}

/** Chinese notes/certification for report body when lang=zh (official English terms retained). */
export function scoreReportZhOverlay() {
  return {
    notes: [
      'DSA 成绩自签发日起有效期为 5 年。',
      '窗口加分（Window Bonus）反映预期学业成长；有效加分（Effective Bonus）按分数余量（Headroom）调整。',
      '计入比例：第 1 次 100%，第 2 次 50%，第 3 次 10%。',
      '为保持透明，该科目所有已计分尝试均予披露。',
    ],
    certification: {
      statement: '本成绩单为 Deep Scholastic Assessment 签发的正式记录。',
      signerName: 'Ergem Fernandez Augusto',
      signer: '首席评估官（Chief Assessment Officer）',
      organization: 'Deep Scholastic Assessment',
    },
    footer: {
      legal: '法律声明：本文件含保密评估数据。未经授权的修改、复制或传播均被严格禁止，并可能追究法律责任。请使用 Report ID 在 verify.dsaexam.com 核验真伪。如发现考试违规，DSA 有权取消成绩。',
      copyright: '© Deep Scholastic Assessment. 禁止擅自复制或篡改本文件。',
    },
  }
}
